'use strict';

exports.__esModule = true;
// https://gist.github.com/padolsey/527683#comment-786682
var getIEVersion = exports.getIEVersion = function getIEVersion() {
    var div = document.createElement('div');
    var all = div.getElementsByTagName('i') || [];

    var v = 3;
    do {
        ++v;
        div.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->';
    } while (all[0]);

    return v > 4 ? v : document.documentMode;
};